import { BadgeCheck, Database, FileCheck2, FileLock2, Gauge, Layers3, MapPinned, Mountain, ScanSearch, ShieldCheck } from "lucide-react";

const modules = [
  { icon: MapPinned, title: "THERA Field Survey", status: "Esqueleto", text: "Levantamientos, GPS/GPX, POI, fotos, observaciones y 360 de campo." },
  { icon: Mountain, title: "THERA Terrain Engine V1", status: "Esqueleto", text: "Perfiles, pendientes, desniveles, altitudes y comparación progresiva con DEM." },
  { icon: Database, title: "POI / THERA Data", status: "Esqueleto", text: "Registro geográfico común para AI, AR, 360, mapas, rutas y navegación." },
  { icon: ScanSearch, title: "THERA 360 Manager", status: "Beta existente", text: "Administración futura de experiencias 360 ligadas a rutas y POI." },
  { icon: BadgeCheck, title: "Validación", status: "Esqueleto", text: "Flujo RAW → pendiente → verificado antes de publicar datos." },
  { icon: FileCheck2, title: "Publicación", status: "Esqueleto", text: "Separa datos internos de información visible para usuarios." },
  { icon: FileLock2, title: "Fuentes y licencias", status: "Esqueleto", text: "Origen, licencia, atribución y uso comercial por registro." },
  { icon: Layers3, title: "THERA Data Layer", status: "Diseño", text: "Overlay independiente. No reemplaza PMTiles, DEM, relieve ni curvas." },
];

export function AdminArchitecturePanel() {
  return (
    <section className="thera-admin-architecture" aria-labelledby="thera-admin-architecture-title">
      <header>
        <div>
          <p className="eyebrow">THERA PRIVATE INFRASTRUCTURE</p>
          <h2 id="thera-admin-architecture-title">Arquitectura interna V1</h2>
          <p>Esqueleto de los módulos privados. Ninguna tarjeta activa todavía procesamiento de producción.</p>
        </div>
        <span><ShieldCheck /> Separado de la app pública</span>
      </header>
      <div className="thera-admin-module-grid">
        {modules.map(({ icon: Icon, title, status, text }) => (
          <article key={title}>
            <span><Icon /></span>
            <div><strong>{title}</strong><small>{text}</small></div>
            <em>{status}</em>
          </article>
        ))}
      </div>
      <div className="thera-admin-engine-note"><Gauge /><p><strong>Protección cartográfica:</strong> THERA Terrain Engine V1 y THERA Data Layer se diseñan como capas adicionales. El mapa actual continúa funcionando aunque estos módulos estén desactivados.</p></div>
    </section>
  );
}
